import React, { useState, useEffect,useCallback } from 'react';
// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { DialogContentText } from "@mui/material";

import Backdrop from '@mui/material/Backdrop';
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from '@mui/material/FormControlLabel';
import CircularProgress from '@mui/material/CircularProgress';

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import {url,urlLive} from "../../constant";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

import dayjs from 'dayjs'; 
import 'dayjs/locale/en-gb'; // Import the locale for British English


function Tables() {
  const [selectedTab, setSelectedTab] = useState(0);
  const [categories, setCategories] = useState([]);
  const [categoryName, setCategoryName] = useState("");
  const [showInFilter, setShowInFilter] = useState(0);
  const [errors, setErrors] = useState({ name: "" });

  // Dialog states for delete and edit confirmation
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [deleteCategoryId, setDeleteCategoryId] = useState(null);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [editCategoryId, setEditCategoryId] = useState(null);
  const [currentPageIndex, setCurrentPageIndex] = useState(0); // Manage pagination state

  // Add loading states
  const [loading, setLoading] = useState(false);  // For fetching categories
  const [formLoading, setFormLoading] = useState(false);  // For form submission
  
  // Fetch categories when the component mounts
  
  useEffect(() => {

    // const requestOptions = {
    //   method: "GET",
    //   redirect: "follow"
    // };

    // fetch(`${url}auth/request-categories`, requestOptions)
    //   .then((response) => response.json())
    //   .then((result) => {
    //     if (result.categories) {
    //       setCategories(result.categories);
    //     }
    //   })
    //   .catch((error) => console.error("Error fetching categories:", error));


    getCategories();

  }, []);

  const getCategories = () => {
    
    setLoading(true);  // Show loader while fetching data
    const requestOptions = {
      method: "GET",
      redirect: "follow"
    };

    fetch(`${url}auth/request-categories`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.categories) {
          setCategories(result.categories);
        }
      })
      .catch((error) => console.error("Error fetching categories:", error))
      .finally(() => {
        setLoading(false);  // Hide loader after fetching
      });

  };

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const validateForm = () => {
    const newErrors = { name: "" };
    let isValid = true;

    if (!categoryName) {
      newErrors.name = "Categoria è obbligatorio";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  // const handleSubmit = () => {
  //   if (validateForm()) {
  //     console.log("Category added:", { categoryName });
  //     setCategoryName(""); // Reset form after submission
  //     setSelectedTab(0);    // Switch back to List tab
  //   }
  // };


  const handleSubmit = () => {
   
    if (validateForm()) {

      setFormLoading(true);  // Show loader during form submission
      // Create a FormData object with the new category name
      const formData = new FormData();
      formData.append("RequestCategory", categoryName);
      formData.append("show_in_filter", showInFilter);
      var akLoginUser = JSON.parse(localStorage.getItem('user'));
      formData.append('CreationUser', `${akLoginUser.user.IdUser}`)

      // Configure the POST request
      const requestOptions = {
        method: "POST",
        body: formData,
        redirect: "follow",
      };

      // Send the POST request to create a new category
      fetch(`${url}auth/request-categories`, requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.success) {
            // Assuming the result includes a success status or newly created category

            // setCategories((prevCategories) => [
            //   ...prevCategories,
            //   { 
            //     IdRequestCategory: result.category.IdRequestCategory,
            //     RequestCategory: categoryName,
            //     CreationDate: formatDate(result.category.CreationDate), 
            //     CreationUser: result.category.CreationUser,

            //   },

            // ]);

            getCategories();
            setCategoryName(""); // Reset form after submission
            setShowInFilter(0);
            setSelectedTab(0); // Switch back to the List tab
            console.log("Category added successfully:", result,result.category.CreationUser);
          } else {
            console.error("Error adding category:", result);
          }
        })
        .catch((error) => console.error("Error adding category:", error))
        .finally(() => {
          setFormLoading(false);  // Hide loader after form submission
        });

    }

  };
  

  const formatDate = (dateString) => {
    if(!dateString){
      return '';
    }
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  const columns = [
    { Header: "#", accessor: "IdRequestCategory" },
    { Header: "Categoria", accessor: "RequestCategory" },
    { Header: "Utente creazione", accessor: "CreationUser" },
    { Header: "Data creazione", accessor: "CreationDate" },
    { Header: "Utente aggiornamento", accessor: "UpdateUser" },
    { Header: "Data aggiornamento", accessor: "UpdateDate" },
    {
      Header: "Mostra in filtro", // New checkbox column
      accessor: "show_in_filter",
      Cell: ({ row }) => (
        <Checkbox
          checked={row.original.show_in_filter}
          onChange={(e) => handleShowInFilterChange(row.original, e.target.checked ? 1 : 0)}
        />
      ),
    },
    { Header: "Actions", accessor: "actions" }, // Action Column
  ];

  const rows = categories.map((category) => ({
    IdRequestCategory: category.IdRequestCategory,
    RequestCategory: category.RequestCategory,
    CreationUser: category.CreationUserName,
    CreationDate: category.CreationDate ? dayjs(category.CreationDate).format('DD-MM-YYYY') : '' ,
    UpdateUser: category.UpdateUserName,
    // UpdateDate: formatDate(category.UpdateDate),
    UpdateDate: category.UpdateDate ? dayjs(category.UpdateDate).format('DD-MM-YYYY') : '' ,
    show_in_filter: category.show_in_filter || false, // default false if not present
    actions: (
      <Box sx={{ display: 'flex', gap: 1 }}>
        {/* Edit Button */}
        <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={() => handleEditDialogOpen(category)}
          sx={{
            fontWeight: 'bold',
            padding: '8px 16px',
            color: '#fff',
           // backgroundColor: '#1976d2',
           backgroundColor: '#183759',
           '&:hover': { 
             // backgroundColor: '#1565c0',
             backgroundColor: '#204b80',
            },
          }}
        >
          {/* Edit */}
          Modifica
        </Button>

        {/* Delete Button */}
        <Button
          variant="contained"
          color="error"
          size="small"
          onClick={() => handleDeleteDialogOpen(category.IdRequestCategory)}
          sx={{
            fontWeight: 'bold',
            padding: '8px 16px',
            backgroundColor: '#d32f2f',
            color: '#fff',
            '&:hover': { backgroundColor: '#c62828' },
          }}
          disabled={category.active}
        >
          {/* Delete */}
          Cancella
        </Button>
      </Box>
    ),
  }));

  const handleEditDialogOpen = (category) => {
    setCategoryName(category.RequestCategory);
    setShowInFilter(category.show_in_filter);
    setEditCategoryId(category.IdRequestCategory);
    setOpenEditDialog(true);
  };

  const handleEditDialogClose = () => {
    setCategoryName("");
    setEditCategoryId(null);
    setOpenEditDialog(false);
  };

  const handleEditSubmit = () => {
    if (validateForm()) {
      const formData = new FormData();
      formData.append("RequestCategory", categoryName);
      formData.append("show_in_filter", showInFilter);

      var akLoginUser = JSON.parse(localStorage.getItem('user'));
      formData.append('UpdateUser', `${akLoginUser.user.IdUser}`)

      const requestOptions = {
        method: "POST",
        body: formData,
        redirect: "follow"
      };

      fetch(`${url}auth/update-request-categories/${editCategoryId}`, requestOptions)
        .then((response) => response.json())
        .then((result) => {
          console.log(result);

          // Update the category list after editing
          // setCategories(categories.map(category =>
          //   category.IdRequestCategory === editCategoryId
          //     ? { ...category, RequestCategory: categoryName }
          //     : category
          // ));

          getCategories();

          handleEditDialogClose();
        })
        .catch((error) => console.error("Error updating category:", error));
    }
  };

  // Open the confirmation dialog for deletion
  const handleDeleteDialogOpen = (categoryId) => {
    setDeleteCategoryId(categoryId);
    setOpenDeleteDialog(true);
  };


  // Close the confirmation dialog without deleting
  const handleDeleteDialogClose = () => {
    setDeleteCategoryId(null);
    setOpenDeleteDialog(false);
  };

  // Perform the delete action if confirmed
  const handleDeleteConfirm = () => {
    const requestOptions = {
      method: "DELETE",
      redirect: "follow"
    };

    fetch(`${url}auth/request-categories/${deleteCategoryId}`, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        console.log(result);
        // Refresh the category list after deletion
        setCategories(categories.filter(category => category.IdRequestCategory !== deleteCategoryId));
        setOpenDeleteDialog(false);
      })
      .catch((error) => console.error("Error deleting category:", error));
  };

  const handleShowInFilterChange = (category, isChecked) => {
    // Optional: Update local state or make API call to save change
    console.log(`Category ID ${category.IdRequestCategory} filter status: ${isChecked}`);

    // Example API call or local update here

    fetch(`${url}auth/request-categories/${category.IdRequestCategory}/show-in-filter`, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        show_in_filter: isChecked,
        // UpdateUser: 'admin' // Replace with actual user if needed
      })
    })
      .then(response => response.json())
      .then(data => {
        if (data.message) {
          console.log('Success:', data.message);
          const updatedCategories = updateShowInFilterInArray(categories, data.category_data);
          // setCategories(updatedCategories);
          // console.log(updatedCategories);
          getCategories();
        } else {
          console.error('Error response:', data.errors || data);
        }
      })
      .catch(error => {
        console.error('Fetch error:', error);
      });


  };

  function updateShowInFilterInArray(categories, categoryData) {
    return categories.map(category => {
      if (category.IdRequestCategory === categoryData.IdRequestCategory) {
        return {
          ...category,
          show_in_filter: categoryData.show_in_filter
        };
      }
      return category;
    });
  }


  return (
    <DashboardLayout>
      <DashboardNavbar />

      {/* Loader Component */}
      <Backdrop open={loading || formLoading} sx={{ color: '#fff', zIndex: 1000 }}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                // bgColor="info"  
                bgColor="#183759"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  {/* Request Category */}
                  Categoria
                </MDTypography>
              </MDBox>

              <Box sx={{ width: '100%' }}>
                <Tabs
                  value={selectedTab}
                  onChange={handleTabChange}
                  indicatorColor="primary"
                  textColor="primary"
                  variant="fullWidth"
                  aria-label="basic tabs example"
                >
                  {/* <Tab label="List Category" />
                  <Tab label="Add Category" /> */}

                  <Tab label="Elenco Categorie" />
                  <Tab label="Nuova Categoria" />

                </Tabs>

                {selectedTab === 0 && (
                  <MDBox pt={3}>
                    <DataTable
                      table={{ columns, rows }}
                      isSorted={false}
                      entriesPerPage={{defaultValue:10}}
                      showTotalEntries={false}
                      noEndBorder
                      currentPageIndex = {currentPageIndex}
                      setCurrentPageIndex = {setCurrentPageIndex}
                    />
                  </MDBox>
                )}

                {selectedTab === 1 && (
                  <MDBox pt={3} px={2}>
                    <MDTypography variant="h6" mb={3} align="center">
                      {/* Add New Category */}
                      Aggiungi nuova categoria
                    </MDTypography>
                    <Grid container spacing={2} justifyContent="center">
                      
                      <Grid item xs={12} sm={8} md={6} lg={5}>

                        <MDBox mb={2}>
                          <TextField
                            // label="Category Name"
                            label="Nome categoria"
                            variant="outlined"
                            fullWidth
                            value={categoryName}
                            onChange={(e) => setCategoryName(e.target.value)}
                            error={!!errors.name}
                            helperText={errors.name}
                            InputLabelProps={{ shrink: true }}
                            sx={{ '& .MuiInputBase-root': { height: '40px' } }}
                          />
                        </MDBox>


                        <MDBox mb={2}>
                          <Button
                            onClick={handleSubmit}
                            variant="contained"
                            color="primary"
                            fullWidth
                            sx={{
                              //  py: 1.5,
                               fontSize: '14px',
                               borderRadius: '8px',
                               height: '40px',
                               color: '#ffffff',
                              // '&:hover': {
                              //   backgroundColor: '#204b80', // ✨ Slightly lighter hover
                              // },
                              backgroundColor: '#183759', // 💙 Base background color
                              '&:hover': {
                                backgroundColor: '#204b80', // ✨ Slightly lighter hover
                              },
                             }}
                             
                          >
                            {/* Add Category */}
                            Salva
                          </Button>
                        </MDBox>


                      </Grid>

                      <Grid item xs={12} sm={8} md={6} lg={5}>


                        <MDBox mb={2}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={showInFilter}
                                onChange={(e) => setShowInFilter(e.target.checked ? 1 : 0)}
                                color="primary"
                              />
                            }
                            label="Mostra questa categoria nel filtro"
                          />
                        </MDBox>

                        
                      </Grid>

                    </Grid>

                            


                  </MDBox>
                )}
              </Box>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />

      {/* Delete Confirmation Dialog */}
      <Dialog
        open={openDeleteDialog}
        onClose={handleDeleteDialogClose}
        fullWidth
        maxWidth="sm"
      >
        {/* <DialogTitle>Confirm Deletion</DialogTitle> */}
        <DialogTitle>Conferma l'eliminazione</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {/* Are you sure you want to delete this category? This action cannot be undone. */}
            Sei sicuro di voler eliminare questa categoria? Questa azione non può essere annullata.    
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteDialogClose} color="primary">
            {/* Cancel */}
            Annulla
          </Button>
          <Button onClick={handleDeleteConfirm} color="error">
          Cancella
          </Button>
        </DialogActions>
      </Dialog>

      {/* Edit Confirmation Dialog */}
      <Dialog
        open={openEditDialog}
        onClose={handleEditDialogClose}
        fullWidth
        maxWidth="sm"
      >
        {/* <DialogTitle>Edit Category</DialogTitle>  */}
        <DialogTitle>Modifica categoria</DialogTitle>
        <DialogContent>
          <TextField
            // label="Category Name"
            label="Categoria"
            variant="outlined"
            fullWidth
            value={categoryName}
            onChange={(e) => setCategoryName(e.target.value)}
            error={!!errors.name}
            helperText={errors.name}
            InputLabelProps={{ shrink: true }}
            sx={{ marginBottom: 2,mt:2 }}
            
          />

          <MDBox mb={2}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={showInFilter}
                  onChange={(e) => setShowInFilter(e.target.checked ? 1 : 0)}
                  color="primary"
                />
              }
              label="Mostra questa categoria nel filtro"
            />
          </MDBox>

        </DialogContent>
        <DialogActions>
          <Button onClick={handleEditDialogClose} color="primary">
            {/* Cancel */}
            Annulla    
          </Button>
          <Button onClick={handleEditSubmit} color="primary">
            {/* Save */}
            Salva
          </Button>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
  
}

export default Tables;
